export class CorrigerDossier
{
    correctionId : String;
    reponse : String;
}
  